<!-- Producto.svelte -->

<script>
	import {getUrl} from '../csql.js'
	import { view_type, usuario } from '../store.js';
	import ProductoExpand from './ProductoExpand.svelte'
	import ProductoForm from './ProductoForm.svelte'
	import ProductoStock from './ProductoStock.svelte'
	//import ProductoCartAdd from './ProductoCartAdd.svelte'
	//import InvoiceAdd from '../cart/InvoiceAdd.svelte'
	import Login from '../usuarios/login.svelte'
	//import Compras from '../compras/compras.svelte'
	import GestorCompras from '../compras/GestorCompras.svelte'

	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();

	export let item= {}

	export let vista_compras = false

	let ver_formulario = false
	let ver_stock = false
	let ver_cart_add = false
	let ver_invoice_add = false
	let ver_login = false

	let expand = false
	let idx = 0
	
	$: images =  item.imagenes.split(",") || ['upm.jpeg']

	function next_image(){
		if((images.length-1) > idx) idx++
		else idx=0
	}
	function prev_image(){
		if(idx>0) idx--
		else idx=images.length-1
	}
	function product_updated(){
		dispatch('updated')
	}

	let articulo = {...item}

	function add_cart(ev){
		let x = ev.detail.prd_detail
		articulo.prd_detail = x
		ver_cart_add = false
		ver_invoice_add = true
	}

	function finalizar(ev){
		let x = ev.detail.prd_detail
		articulo.prd_detail = x
		ver_cart_add = false
		ver_invoice_add = true
	}

	function agregar_producto(){
		//console.log($usuario)
		if(!$usuario.email?.length){
			ver_login = true
		}else{
			ver_cart_add=true
		}

	}

	function cerrar_login(){
		ver_login = false
		ver_cart_add=true
	}

	function close(){
		vista_compras = false
	}

	function handler2(args){
		close()
	}

</script>

<div class="sma0ll card" style="font-size:0.9rem;border: 3px solid #999;border-radius: 5px;padding:5px;">
	{#if $usuario.tipo==='ADMIN'}
		<div class="row" style="font-size:0.7em;">
			<div class="col-sm h-center inverse" on:click={()=>ver_formulario=true}>Editar</div>
			<div class="col-sm h-center inverse" on:click={()=>ver_stock=true}>Stock</div>
		</div>
	{/if}
	<div class="slider">
		<img class="img " src={'upload/'+images[idx]} alt="" style="">
		<div class="row expand v-center" style="background-color: #888888;">
			<div class="col-sm-1">&nbsp;</div>
			{#if idx>0}
				<div class="col-sm-3 text-center control" on:click={prev_image}>&nbsp;<img src="images/angle-left.svg" alt=""></div>
			{:else}
				<div class="col-sm-3 text-center">&nbsp;</div>
			{/if}
			<div class="col-sm-3 text-center control" on:click={()=>expand=true}><img src="images/search-plus.svg" alt=""></div>
			{#if idx<images.length-1}
				<div class="col-sm-3 text-center control" on:click={next_image}>&nbsp;<img src="images/angle-right.svg" alt=""></div>
			{:else}
				<div class="col-sm-3 text-center">&nbsp;</div>
			{/if}
			<div class="col-sm-2">&nbsp;</div>
		</div>
			
<!-- 
		<span class="" on:click={()=>expand=true}>
		<span class="expand v-center" on:click={()=>expand=true}>
			<img src="images/search-plus.svg" alt="">
		</span> -->
			
		<!-- <span class="button expand v-center">&#128270;</span> -->
	</div>

		
	<div class="section text-xs">
			<p style="text-align:right;font-size:0.6em;color:#777777;margin:0;">#{item.id}</p>
		<div class="row">
			<h5>{item.nombre}</h5>
		</div>
		<div class="row">{item.descrp}</div>
			<!-- <p class="desc" style="font-size:0.8rem;padding:2px 4px;">{item.descrp}</p> -->
		<div class="row h-center v-center">
			<button class="v-center" style="background-color:black;color:white; padding:3px 20px;margin-right:20px;" on:click={()=>vista_compras=true}>
				<img src="images/shopping-cart.svg" height="12px" alt="">&nbsp;Añadir al carrito
			</button>
			<!-- <a href="https://wa.me/5491130503438?text=(UP+)%20Consulta%20art:%20{item.id}%20{item.nombre.replace(/ /g,'%20')}">
				<img src="https://icongr.am/fontawesome/whatsapp.svg?size=16&color=ffffff" alt="" 
				style="padding:3px;background-color:#46ad01;border-radius:3px;">
			</a> -->
		</div>
		<div>
			{#if (!$usuario.tipo || $usuario.tipo==='MINO' || $usuario.tipo==='ADMIN')}
				<div style="text-align: right">
					<b>$ {(parseFloat(item.importe1||0)).toFixed(2)}</b>
				</div>
			{/if}
			{#if ($usuario.tipo==='MAYO' || $usuario.tipo==='ADMIN')}
				<div style="text-align: right">
					<i style="padding-right: 0 4px;">(x mayor)</i><b>$ {(parseFloat(item.importe0|0)).toFixed(2)}</b>
				</div>
			{/if}
		</div>
		{#if $usuario.tipo==='ADMIN'}
			<div>
				<a href="whatsapp://send?text=https://unpocomasindumentaria.com?pid={getUrl(item.id)}">Compartir</a>
				<!-- <span style="color:blue;" on:click="{()=>alert("https://unpocomasindumentaria.com?pid="+getUrl(item.id))}">Publicar</span> -->
			</div>
			
		{/if}


		

	</div>	
</div>


	{#if vista_compras}
		<!-- <Compras {close} {item} evento="agregar"/> -->

		<GestorCompras articulo={item} {handler2}>
			<span slot="salir"><button on:click={close}>Volver al Catalogo</button></span>
		</GestorCompras>

	{/if}

<!-- 
	{#if $view_type==='grid'}


		<div class="my-2 md:mx-2 flex flex-col flex-none md:border border-b-8 border-gray-300 md:rounded sm:w-full md:w-64 lg:w-64 relative">

			<img src={'upload/'+images[idx]} alt="" class="mx-auto w-full" style="width:180px;object-fit: contain; ">
			<div class="w-full flex text-xs">
				{#if $usuario.tipo==='ADMIN'}
					<span class="w-1/2 border text-center bg-red-100 hover:bg-red-50 hover:text-red-500" on:click={()=>ver_formulario=true}><small>Editar</small></span>
					<span class="w-1/2 border text-center bg-red-100 hover:bg-red-50 hover:text-red-500" on:click={()=>ver_stock=true}><small>Stock</small></span>
				{/if}
			</div>
			<div class="my-2 px-4 flex-grow flex flex-col">
				<p class="text-gray-300 text-xs text-right">#{item.id}</p>
				<p class="text-xs font-bold">{item.nombre}</p>
				<p class="text-sm w-full flex-grow">{item.descrp}</p>

				<p class="text-center"> 
					<button class="bg-pink-700 text-white font-bold py-1 px-3 my-2 text-xs rounded-xl" on:click={agregar_producto}>
						<img src="images/cart.jpg" width="20px" alt="" class="inline rounded-full">&nbsp;Agregar al Carrito
					</button>
				</p>
			
				<div class="w-full self-end">
	
					{#if $usuario.tipo==='MAYO'}
						<p class="flex justify-between content-center text-right pr-2 mt-2 pt-1 border-t border-blue-200">
		
							<i class="text-xs">MAYORISTA</i><b>$ {(parseFloat(item.importe0|0)).toFixed(2)}</b>
						</p>
					{:else}
						<p class=" flex justify-between content-center text-right pr-2 mt-2 pt-1 border-t border-blue-200">
							<i class="text-xs">MINORISTA</i><b>$ {(parseFloat(item.importe1||0)).toFixed(2)}</b>
						</p>
					{/if}
				</div>
			</div>
			{#if idx>0}
				<button on:click="{prev_image}" class="absolute top-1/4 left-1 text-white font-bold py-1 px-3 border border-white rounded border-out">&laquo;</button>
			{/if}
			{#if (images.length-1)>idx}
				<button on:click="{next_image}" class="absolute top-1/4 right-1 text-white font-bold py-1 px-3 border border-white rounded border-out">&raquo;</button>
			{/if}
			<button on:click={()=>expand=true} 
					class="absolute top-2 right-1 text-white font-bold py-1 px-3 border border-white rounded border-out" title="Ver Detalles">
				&nearhk;
			</button>
		</div>
	{/if}

	{#if $view_type==='list'}

		<div class="my-2 mx-2 px-2 flex border border-gray-300 rounded  justify-between relative hover:bg-green-100">
			<figure>
				<img src={'upload/'+images[idx]} alt="" class="h-20" on:click={()=>expand=true}>
				<figcaption class="text-center text-xs"><small>({images.length} foto{images.length>1?'s':''})</small></figcaption>
			</figure>
			<div class="mt-1 pl-4 flex-1">
				<p class="text-gray-300 text-xs text-right">#{item.id}</p>
				<p class="text-xs font-bold">{item.nombre}</p>
				<p class="text-sm w-full">{item.descrp}</p>

				<p class="text-right pr-2 mt-2 pt-1 border-t border-blue-200">$ {(parseFloat(item.importe1||0)).toFixed(2)}</p>
			</div>
		</div>
		
	{/if}
 -->

{#if expand}
	<ProductoExpand {item} {idx} bind:visible={expand} />	
{/if}

{#if ver_formulario}
	<ProductoForm {item} bind:visible={ver_formulario} on:updated={product_updated}/>
{/if}

{#if ver_stock}
	<ProductoStock {item} bind:visible={ver_stock}/>
{/if}

<!-- {#if ver_cart_add}
	<ProductoCartAdd {item} bind:visible={ver_cart_add} on:insert={add_cart} on:comprar={finalizar}/>
{/if}

{#if ver_invoice_add}
	<InvoiceAdd {articulo} bind:visible={ver_invoice_add}/>
{/if}
 -->
{#if ver_login}
	<Login bind:visible={ver_login} on:close={cerrar_login}><p class="text-white">Para continuar su compra ingrese su email</p><br></Login>
{/if}

<style>
	.slider{
		display: flex;
	    width: 100%;
	    /*scroll-snap-type: x mandatory;*/
	    overflow-x: hidden;
	    overflow-y: hidden;
	    /*scrollbar-color: red yellow;*/
	}

	.img {
		flex: 0 0 100%;
		width: 100%;
		object-fit: contain;
		scroll-snap-align: center;
		height: 300px;
		/*max-width:200px;*/
		/*margin-right: 16px;*/
		/*margin-left: 16px;*/
	}
	.expand{
		position: absolute;
		top:260px;
		left:0px;
		height:auto;
		width:80%;
		margin: 0 10%;
		padding:8px;
		/*font-size:30px;*/
		opacity: 0.4;
		border-radius: 4px;
		/*border:solid 1px black;*/
		background-color: #666666;
	}
	.control:hover{
		background-color: #444444;
		border-radius: 5px;
	}

</style>